import { Button, Tooltip } from '@mui/material';
import { makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import GabineteStore from '../../store/GabineteStore';
import RouterStore from '../../store/RouterStore';
import FiltroStore from '../../store/FiltroStore';
import '../css/visualizacaoServidor.css';
import ControleGabineteStore from '@/store/ControleGabineteStore';

interface IPropsVisualizaCountProcesso {
    servidor: any;
    controleTitulo?: string;
    controleNumero: number;
    isConfig?: boolean;
}


class VisualizaCountProcesso extends React.Component<IPropsVisualizaCountProcesso> {
    sincronizarFiltroResponsavelEscaninho = (responsavel: string) => {
        FiltroStore.usuarioSelecionadoFilter = [];
        FiltroStore.possuiResponsavel = false;
        FiltroStore.naoPossuiResponsavel = false;

        if (responsavel === 'null') {
            FiltroStore.naoPossuiResponsavel = true;
            return;
        }

        FiltroStore.usuarioSelecionadoFilter = [responsavel];
    };

    redirecionaParaEscaninho = () => {
        const controleNumero = this.props.controleNumero;
        const responsavel = this.props.servidor?.cpf || 'null';
        const ojc = ControleGabineteStore.filtroOJC;
        let ojcParam: string;

        this.sincronizarFiltroResponsavelEscaninho(responsavel);

        if (!ojc) {
            ojcParam = 'null';
        } else if (Array.isArray(ojc)) {
            const listaNormalizada = ojc.map(item =>
                item.trim().toUpperCase() === 'SEM OJC CADASTRADO' ? 'SEM_OJC' : item.trim()
            );
            ojcParam = encodeURIComponent(listaNormalizada.join(',')).replace(/%2C/g, ',');
        } else {
            const normalizado =
                ojc.trim().toUpperCase() === 'SEM OJC CADASTRADO'
                    ? 'SEM_OJC'
                    : ojc.trim();
            ojcParam = encodeURIComponent(normalizado);
        }

        if (!ojc) {
            RouterStore.push(
                `/escaninho/gerencial?controleNumero=${controleNumero}&responsavel=${responsavel}`
            );
        } else {
            RouterStore.push(
                `/escaninho/gerencial?controleNumero=${controleNumero}&responsavel=${responsavel}&OJC=${ojcParam}`
            );
        }
    };

    constructor(props: IPropsVisualizaCountProcesso) {
        super(props);

        makeObservable(this, {
});
    }

    get nome() {
        return this.props.servidor?.nome
            || GabineteStore.recuperarNomeServidor(this.props.servidor?.cpf)
            || this.props.servidor?.cpf
            || "Sem Responsável";
    }

    render() {
        const isLista = ControleGabineteStore.isVisualizacaoEmLista
        return (
            <Tooltip title="" key={'' + this.props.controleNumero + this.props.servidor.nome + this.props.servidor.count}>
                <Button
                    onClick={!this.props.isConfig ? this.redirecionaParaEscaninho : undefined}
                    className={`item-conteudo ${this.props.isConfig ? 'item-conteudo-disabled' : ''}`}
                    variant="text"
                    size="small"
                    fullWidth
                    disableRipple={this.props.isConfig}
                >
                        <span className={isLista ? 'texto-conteudo-lista' : 'texto-conteudo'}>
                            {this.nome}
                        </span>
                        <span className="contador-conteudo">
                            {this.props.servidor.count}
                        </span>
                </Button>
            </Tooltip>
        );
    }
}

export default observer(VisualizaCountProcesso);
